import { scaleBand, scaleLinear, scaleSymlog, scaleTime } from 'd3-scale';
import horiMixin from '../horizontalPlots';

const repoMixin = {
  mixins: [horiMixin],
  data() {
    return {
      configProp: '',
      handler: false,
      dynamicStart: null,
      dynamicEnd: null,
      plotTypes: ['plotStart', 'plot'],
      scales: {
        band: scaleBand,
        linear: scaleLinear,
        symlog: scaleSymlog,
        time: scaleTime,
      },
      transposeScale: this.transpose ?? false,
    };
  },
  computed: {
    plotxScale() {
      if (this.scaleTypeX === 'band' || this.transposeScale) {
        return this.scales[this.scaleTypeX]().domain(this.bandX).range(this.rangeX);
      }

      return this.xScale;
    },
    xScale() {
      return this.scales[this.scaleTypeX]().domain(this.domainX).range(this.rangeX);
    },
    yScale() {
      const scale = this.transposeScale
        ? this.h_yScale
        : this.scales[this.scaleTypeY]().domain(this.domainY).range(this.rangeY).clamp(true);

      if (this.scaleTypeY === 'symlog') {
        scale.constant(this.symlogConstant);
      }

      return scale;
    },
  },
  methods: {
    getScaleX(x) {
      const newX = this.scaleTypeX === 'time' ? new Date(x) : x;
      return this.scaleTypeX === 'band'
        ? newX * this.plotxScale.bandwidth()
        : this.plotxScale(newX);
    },
    repositioning(e) {
      this.trap(e);

      this.dragStart(e);

      document.body.addEventListener('mouseup', this.dragEnd);
    },
    dragStart(e) {
      this.dragging = {
        offsetX: e.offsetX,
        offsetY: e.offsetY,
      };

      document.body.addEventListener('mousemove', this.drag);
    },
    drag(e) {
      const dynamicSide = this.plotTypes.includes(this.configProp) ? 'dynamicStart' : 'dynamicEnd';
      const { x, y } = this[dynamicSide] != null ? this[dynamicSide] : this;

      this.trap(e);

      // reposition
      const xMove = e.movementX;
      const yMove = e.movementY;

      let newX = xMove !== 0 || x == null ? e.offsetX : x;
      newX = this.handler ? (x || e.offsetX) + e.movementX : newX;
      let newY = yMove !== 0 || y == null ? e.offsetY : y;
      newY = this.handler ? (y || e.offsetY) + e.movementY : newY;

      this[dynamicSide] = { x: newX, y: newY };
      if (this.handler) {
        this.$emit('pftracking', { x: this[dynamicSide].x, y: this[dynamicSide].y });
      }

      this.dragging = {
        offsetX: e.offsetX,
        offsetY: e.offsetY,
      };
    },
    dragEnd() {
      const { drag } = this;
      const dynamicSide = this.plotTypes.includes(this.configProp) ? 'dynamicStart' : 'dynamicEnd';

      this.dragging = false;

      if (this.configuration && this[dynamicSide] != null) {
        this.updatePosition(this.configProp, this[dynamicSide]);
      }

      document.body.removeEventListener('mousemove', this.drag);
      document.body.removeEventListener('mouseup', this.dragEnd);
    },
    setXPosition(x) {
      let newX = this.scaleTypeX === 'band' ? x / this.plotxScale.bandwidth() : x;
      newX = this.handler && this.scaleTypeX !== 'band' ? newX - this.yAxisWidth : newX;
      return this.scaleTypeX === 'band' ||
        (isNaN(this.plotxScale.invert(newX)) && this.scaleTypeX !== 'time')
        ? newX
        : this.plotxScale.invert(newX);
    },
    setYPosition(y) {
      return this.transposeScale || Number.isNaN(this.yScale.invert(y)) ? y : this.yScale.invert(y);
    },
    updatePosition(prop, val) {
      const { x, y } = val;

      let plotX = this.setXPosition(x);
      const plotY = this.setYPosition(y);

      if (this.scaleTypeX === 'time') {
        plotX = plotX.toString();
      }

      this.emitProp(prop, { x: plotX, y: plotY });
    },
    emitProp(prop, val) {
      const obj = {};
      obj.prop = prop;
      obj.value = val;

      this.$emit('pfmoveevent', obj);
    },
    trap(event) {
      event.stopPropagation();
      event.preventDefault();
    },
  },
};

export default repoMixin;
